import Vue from 'vue'
import Router from 'vue-router'

import PageAbout from '../components/PageAbout';
import PageIndex from '../components/PageIndex';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: PageIndex
    },
    {
      path: '/about',
      component: PageAbout
    }
  ]
})